import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-cookie-consent', 'title', 'Наши файлы cookie, Ваши настройки');
Labels.set(
    'ui-cookie-consent',
    'info',
    'Зарегистрированные в {country} {entitiesLink} группы Swedbank используют {cookiesLink} (или тому подобные технологии), чтобы персонализировать Ваше обслуживание и повышать эффективность сайта. Для получения дополнительной информации ознакомьтесь с нашей {policyLink}.\n\nНажав на «Согласиться», Bы соглашаетесь с необязательными аналитическими и таргетинговыми файлами cookie, в свою очередь. Hажав на «Отклонить», Bы отказываетесь от этих файлов cookie. Нажав на кнопку «Выбрать файлы cookie», Вы можете выбрать, какие файлы cookie Вы примете. Вы можете отозвать свое согласие на использование файлов cookie в любое время на странице «{usageLink}».'
);
Labels.set(
    'ui-cookie-consent',
    'disclaimer',
    'Некоторые файлы cookie необходимы для работы этого сайта. Такие файлы cookie обрабатываются на основании наших законных интересов, поэтому для них не требуется согласия пользователя.'
);
Labels.set('ui-cookie-consent', 'accept', 'Согласиться');
Labels.set('ui-cookie-consent', 'decline', 'Отклонить');
Labels.set('ui-cookie-consent', 'saveChoice', 'Сохранить мой выбор');
Labels.set('ui-cookie-consent', 'myCookies', 'Выбрать файлы cookie');
Labels.set(
    'ui-cookie-consent',
    'policyLinkLabel',
    'политикой в отношении файлов cookie'
);
Labels.set('ui-cookie-consent', {
    HELP_NECESSARY:
        'Необходимы для функционирования этого сайта. Их нельзя отключить, поэтому согласие пользователя не требуется.',
    HELP_ANALYTICAL:
        'Помогают улучшить работу сайта путем учитывания количества и источников посещения сайта. В случае отказа ваше посещение сайта не будет включено в статистику.',
    HELP_TARGETING:
        'Помогают предоставить вам персонализированную информацию о наших продуктах и услугах. В случае отказа вам не будет предлагаться персонализированное содержание.',
    HELP_FUNCTIONAL:
        'Эти файлы cookie обеспечивают улучшенные функции сайта. Если Вы отклоните эти файлы cookie, это может ограничить некоторые функции, но основные операции сайта останутся без изменений.',
});
Labels.set('ui-cookie-consent', {
    CATEGORY_NECESSARY: 'Необходимые',
    CATEGORY_ANALYTICAL: 'Аналитические',
    CATEGORY_TARGETING: 'Для отбора целевой аудитории',
    CATEGORY_FUNCTIONAL: 'Функциональные',
});
Labels.set('ui-cookie-consent', 'EE', 'Эстонии');
Labels.set('ui-cookie-consent', 'LV', 'Латвии');
Labels.set('ui-cookie-consent', 'LT', 'Литве');
Labels.set('ui-cookie-consent', 'entities', 'предприятия');
Labels.set('ui-cookie-consent', 'cookies', 'файлы cookie');
Labels.set('ui-cookie-consent', 'language', 'Язык');
Labels.set('ui-cookie-consent', 'usage', 'Файлы cookie');
